import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=3573e2cc&scoped=true&"
import script from "./ItemSelector.vue.ts?vue&type=script&lang=js&"
export * from "./ItemSelector.vue.ts?vue&type=script&lang=js&"
import style0 from "./ItemSelector.vue.scss?vue&type=style&index=0&id=3573e2cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573e2cc",
  null
  
)

export default component.exports